
import './mapLogo.css'

import LogoIcon from '../../assets/img/ZoomRadarLogo.svg';
import { useContext } from 'react';
import parameterContext from '../../context/parameterContext';

export const MapLogo = () => {
    const parameters = useContext(parameterContext);
    let image = LogoIcon;
    const width = '100%';
    let height = 50;
    let extraClass =''
    if (parameters?.custom_logo){
        image = parameters.custom_logo;
        if (parameters?.logo_height){
            height = parameters.logo_height;
        }
    }
    if (parameters?.top_left_logo){
        extraClass ='top-left'
    }
    
    
    return(
        <>
            <div className={"logo-icon "+extraClass} >
                <img src={image} alt={'Map Logo Image'}
                style={ parameters?.custom_logo && {
                        width: width,
                        height:height
                    }
                }/>
            </div>
        </>
    )
}
